export default "__VITE_ASSET__zESQ3Noa__"